import React from 'react';

const GraystoneGroupSolutionsLogo = (props: any) => (
  <svg
  viewBox="0 0 122 49"
  xmlns="http://www.w3.org/2000/svg"
    className="rethink-sans"
    {...props}
    transform="scale(1,1)"

  >
    {/* Black rounded square */}
    <g transform="matrix(1 0 0 1 0 0)" >
      <rect
        x="0"
        y="0"
        width="43.7"
        height="48.2"
        rx="6.22"
        ry="6.22"
        fill={props.boxColor || "#020202"}
      />
    </g>
    <text
      x="23.5"
      y="28.5"
      fontFamily="Rethink Sans, sans-serif"
      fontSize="44"
      fontWeight="700"
      fill={props.textColor || "#fff"}
      dominantBaseline="middle"
      textAnchor="middle"
      transform="scale(0.925,1)"
    >
      G
    </text>
    {/* Company name */}
    <text
      x="38"
      y="20"
      fontFamily="Rethink Sans, sans-serif"
      fontSize="12"
      fontWeight="700"
      fill={props.nameColor || "#fff"}
    >
      <tspan x="50" y="28">GRAYSTONE</tspan>
    </text>
  </svg>
);

export default GraystoneGroupSolutionsLogo; 